import * as React from "react";
import { render } from "react-dom";

import { App } from "../react/containers/index/App";


const elem = document.getElementById("application");


render(
  <App/>,
  elem,
);

/*
const costs: number[] = [ 590, 560, 450, 420, 280, 270, 200, ];
let result = ``;

for (const a of costs) {
  for (const b of costs) {
    let max = 0;
    for (const na of [0, 1, 2, 3, 4]) {
      for (const nb of [0, 1, 2, 3, 4]) {
        const c = a * na + b * nb;
        if (c < 1000 && max < c) {
          if ((na === 0 || nb === 0) && (1 < na + nb)) {
            continue;
          }

          max = c;
        }
      }
    }

    result += `{ a: UnitCost.cost${a}, b: UnitCost.cost${b}, maxTeamCost: ${max}, },` + "\n";
  }
}

console.log(result);
*/
